module.exports = __webpack_public_path__ + "static/media/aluminio-blank.dd909e71.jpg";